import { FC } from 'react'
import CustomLabel from '../CustomLabel'
import CustomInput from '../CustomInput'
import { maxLengthRule, requiredRule } from '../../utils/formRules'
import { TControls } from '../../../features/userInfoForm/types'

const Street: FC<TControls> = ({ control }) => (
  <div>
    <CustomLabel label="Street *"/>
    <CustomInput
      name="street"
      control={control}
      rules={{
        required: requiredRule(),
        maxLength: maxLengthRule(50)
      }}
    />
  </div>
)
export default Street
